// Import model
import { AugmentedTag } from '../models/AugmentedTag';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AugmentedTag - handles JSON serialization and deserialization with type validation
 */
export class AugmentedTagSerializer {
  /**
   * Deserializes a JSON string into a AugmentedTag instance
   */
  static deserialize(json: string): AugmentedTag {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AugmentedTag instance
   */
  static fromObject(obj: any): AugmentedTag {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AugmentedTag');
    }


    const instance: AugmentedTag = {
      tag: obj['Tag'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AugmentedTag instances
   */
  static deserializeArray(json: string): AugmentedTag[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AugmentedTag instance to a JSON string
   */
  static serialize(instance: AugmentedTag): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AugmentedTag instance to a plain object
   */
  static toObject(instance: AugmentedTag): any {
    return {
      'Tag': instance.tag,
    };
  }

  /**
   * Serializes an array of AugmentedTag instances to a JSON string
   */
  static serializeArray(instances: AugmentedTag[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
